var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import iconInfo from "../../../assets/icons/feather/info.svg";
import "./scratch.cards.css";
import { useNavigate, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { ScratchCardMyCards } from "./scratch.my.cards";
import Modal from "react-modal";
import _ from "lodash";
import iconClose from "../../../assets/icons/feather/x-circle.svg";
import couponBg from "../../../assets/images/inner-scratch.png";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import couponCover from "../../../assets/images/win-point-scracth.png";
import ScratchCard from "react-scratchcard";
import { exceptionModal, getGameItem, gtmViewItem, loadingAnimation, loginRequired, useForceUpdate, } from "../../../services/misc.functions";
import { env } from "../../../constants/global.constants";
import { api } from "../../../services/http.service";
import { scratchCards } from "../../../store/games.store";
import { isMobile } from "../../../App";
import { modalServiceSubject } from "../../../services/modal.service";
import { auth } from "../../../store/auth.store";
import { openCreditCartModal } from "../../../services/websocket.service";
import { GameInfo } from "../game.info";
import paths from "../../../paths";
export function ScratchCards() {
    var _this = this;
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var params = useParams();
    var _a = useState(null), shownDraw = _a[0], setShownDraw = _a[1];
    var _b = useState(null), game = _b[0], setGame = _b[1];
    useEffect(function () {
        if (params.subpage === undefined) {
            var game_1 = getGameItem("kazi_kazan");
            if (game_1 != null && game_1.is_active) {
                setGame(game_1);
            }
        }
    }, [params.subpage]);
    useEffect(function () {
        if (params.subpage === undefined) {
            gtmViewItem([{ code: "kazi_kazan", name: "KAZI Kazan" }], "Oyunlar");
            getDraws();
        }
    }, [pathname]);
    var getDraws = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadingAnimation(true);
                    return [4 /*yield*/, api
                            .start("get", env.accounting_api + "/somos/api/kazi-kazan/cekilis/", null, false)
                            .then(function (res) {
                            loadingAnimation(false);
                            // console.log(res)
                            scratchCards.splice(0, scratchCards.length);
                            scratchCards.push.apply(scratchCards, res.data);
                            forceUpdate();
                        })
                            .catch(function (e) {
                            exceptionModal(e);
                            setTimeout(function () {
                                getDraws();
                            }, 3000);
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var loadMore = function (e) {
        e.target.disabled = true;
        getDraws().finally(function () {
            e.target.disabled = false;
        });
    };
    return (_jsxs(_Fragment, { children: [isMobile && (_jsx("div", __assign({ className: "row inner-page-top-tabs" }, { children: _jsxs("div", __assign({ className: "liner-tabs", style: { "--tab-count": "3" } }, { children: [_jsx("input", { type: "radio", value: "0", checked: params.subpage === undefined, "data-rel": "tab1", id: "raffle-id_tab-1", onChange: function () {
                                navigate(paths.scratch.url);
                            }, name: "tabs" }), _jsx("label", __assign({ className: "tab", htmlFor: "raffle-id_tab-1" }, { children: "Kaz\u0131 Kazan" })), _jsx("input", { type: "radio", value: "1", "data-rel": "tab2", checked: params.subpage === "kartlarim", id: "raffle-id_tab-2", onChange: function () {
                                navigate(paths.scratch.url + "/kartlarim");
                            }, name: "tabs" }), _jsx("label", __assign({ className: "tab", htmlFor: "raffle-id_tab-2" }, { children: "Kartlar\u0131m" })), _jsx("input", { type: "radio", value: "2", "data-rel": "tab3", checked: params.subpage === "kurallar", id: "raffle-id_tab-3", onChange: function () {
                                navigate(paths.scratch.url + "/kurallar");
                            }, name: "tabs" }), _jsx("label", __assign({ className: "tab", htmlFor: "raffle-id_tab-3" }, { children: "Kurallar" })), _jsx("span", { className: "glider" })] })) }))), !isMobile && (_jsx("div", __assign({ className: "row mt-3" }, { children: _jsx("div", __assign({ className: " mb-3" }, { children: _jsxs("div", __assign({ className: "slider-tabs", style: { "--tab-count": "3" } }, { children: [_jsx("input", { type: "radio", value: "0", checked: params.subpage === undefined, "data-rel": "tab1", id: "raffle-id_tab-1", onChange: function () {
                                    navigate(paths.scratch.url);
                                }, name: "tabs" }), _jsx("label", __assign({ className: "tab", htmlFor: "raffle-id_tab-1" }, { children: "Kaz\u0131 Kazan" })), _jsx("input", { type: "radio", checked: params.subpage === "kartlarim", value: "1", "data-rel": "tab2", id: "raffle-id_tab-2", onChange: function () {
                                    navigate(paths.scratch.url + "/kartlarim");
                                }, name: "tabs" }), _jsx("label", __assign({ className: "tab", htmlFor: "raffle-id_tab-2" }, { children: "Kartlar\u0131m" })), _jsx("input", { type: "radio", checked: params.subpage === "kurallar", value: "2", "data-rel": "tab3", id: "raffle-id_tab-3", onChange: function () {
                                    navigate(paths.scratch.url + "/kurallar");
                                }, name: "tabs" }), _jsx("label", __assign({ className: "tab", htmlFor: "raffle-id_tab-3" }, { children: "Kurallar" })), _jsx("span", { className: "glider" })] })) })) }))), _jsxs("div", __assign({ className: "row" }, { children: [params.subpage === undefined && (_jsx(_Fragment, { children: scratchCards.map(function (card, key) {
                            return (_jsx(ScratchCardWidget, { setShownDraw: setShownDraw, draw: card }, "scratch-card-".concat(key)));
                        }) })), params.subpage === "kartlarim" && (_jsx(_Fragment, { children: _jsx(ScratchCardMyCards, {}) })), params.subpage === "kurallar" && (_jsx(_Fragment, { children: _jsx(ScratchCardRules, {}) })), _jsxs("div", __assign({ className: "text-center" }, { children: [_jsx("div", { id: "id_loaderAnimation", className: "loader" }), _jsx("button", __assign({ id: "id_datalist_loadmore", onClick: loadMore, type: "button", className: "btn rounded-pill btn-outline-primary" }, { children: "Devam\u0131n\u0131 Y\u00FCkle" }))] })), _jsx(GameInfo, { game: game })] })), _jsx(Modal, __assign({ isOpen: shownDraw !== null ? true : false, className: "default", onRequestClose: function () {
                    setShownDraw(null);
                } }, { children: shownDraw && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "modal-close" }, { children: _jsx("img", { src: iconClose, width: 24, className: "float-right cursor-p ", onClick: function () { return setShownDraw(null); } }) })), _jsx("div", __assign({ className: "modal-header" }, { children: _jsx("h2", __assign({ className: "fw-bolder text-center text-primary" }, { children: "\u0130kramiye Bilgileri" })) })), _jsx("div", __assign({ className: "modal-body" }, { children: _jsxs("table", __assign({ className: "table table-borderless scratch-card-info" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "\u0130kramiyeler" })), _jsx("th", __assign({ className: "text-end" }, { children: "Adet" }))] }) }), _jsx("tbody", { children: _.orderBy(shownDraw.prizes, function (o) {
                                            return Number(o.approximate_price.replaceAll(".", "").replaceAll(",", ".").replaceAll("₺", ""));
                                        }, ["desc"]).map(function (p, key) {
                                            return (_jsxs("tr", { children: [_jsx("td", __assign({ className: "text-left" }, { children: _jsx("div", __assign({ className: "ms-2" }, { children: shownDraw.is_hybrid ? p.name : p.approximate_price })) })), _jsx("td", __assign({ className: "text-end" }, { children: _jsx("div", __assign({ className: "me-2" }, { children: p.price_count })) }))] }, "prize__scratch_" + key));
                                        }) })] })) })), _jsxs("div", __assign({ className: "modal-ticket-footer text-end" }, { children: [_jsx("div", { className: "wave" }), _jsx("div", __assign({ className: "body-row row" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("button", __assign({ className: "btn w-100 custom-btn-danger", onClick: function () {
                                                setShownDraw(null);
                                            } }, { children: "Kapat" })) })) }))] }))] })) }))] }));
}
export function ScratchCardRules() {
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "p-3" }, { children: [_jsx("h4", __assign({ className: "fs-5 fw-bold mb-3" }, { children: "Nas\u0131l Oynan\u0131r?" })), _jsxs("ol", { children: [_jsx("li", { children: "\u0130stedi\u011Finiz e-\u015Eans Kaz\u0131 Kazan kart\u0131ndan en az 1 en fazla 100 adet sat\u0131n al\u0131n." }), _jsx("li", { children: "Ald\u0131\u011F\u0131n\u0131z kartlar\u0131 KARTLARIM sayfas\u0131nda g\u00F6rebilir ve kaz\u0131ma i\u015Flemine ba\u015Flayabilirsiniz." }), _jsx("li", { children: "e-\u015Eans Kaz\u0131 Kazan kart\u0131 \u00FCzerinde parma\u011F\u0131n\u0131z\u0131 kayd\u0131rarak kart kaz\u0131ma i\u015Flemini yapabilirsiniz." }), _jsx("li", { children: "Kart\u0131 otomatik kaz\u0131 butonu yard\u0131m\u0131 ile kart\u0131n\u0131z\u0131 kaz\u0131yabilir veya T\u00DCM\u00DCN\u00DC OTOMAT\u0130K KAZI butonu ile h\u0131zl\u0131ca elinizdeki kartlar\u0131 kaz\u0131yabilirsiniz." })] })] })), _jsxs("div", __assign({ className: "p-3" }, { children: [_jsx("h4", __assign({ className: "fs-5 fw-bold mb-3" }, { children: "Oyun Kurallar\u0131?" })), _jsxs("ol", { children: [_jsx("li", { children: "e-\u015Eans Kaz\u0131 Kazan, geleneksel Kaz\u0131 Kazan oyunu \u00FCzerine kurgulanm\u0131\u015Ft\u0131r." }), _jsx("li", { children: "Her bir kartta 6 adet ikramiye rakam\u0131 yer al\u0131r." }), _jsx("li", { children: "\u0130kramiye rakamlar\u0131n\u0131n yer ald\u0131\u011F\u0131 alan kaz\u0131nd\u0131\u011F\u0131nda veya otomatik olarak a\u00E7\u0131ld\u0131\u011F\u0131nda, a\u00E7\u0131\u011Fa \u00E7\u0131kan 6 adet ikramiye rakam\u0131ndan 3 adedinin ayn\u0131 olmas\u0131 halinde, ayn\u0131 ikramiye rakamlar\u0131n\u0131n g\u00F6sterdi\u011Fi bir adet ikramiye kazan\u0131l\u0131r." }), _jsx("li", { children: "Sat\u0131n al\u0131nan kartlar\u0131n ayn\u0131 g\u00FCn 23:00'e kadar kaz\u0131nmas\u0131 gerekmektedir." }), _jsx("li", { children: "G\u00FCn sonuna kadar kaz\u0131nmayan kartlar otomatik olarak sonu\u00E7land\u0131r\u0131lacak ve ikramiye isabet eden kartlar\u0131n ikramiyeleri otomatik olarak bakiyeye yans\u0131t\u0131lacakt\u0131r." }), _jsxs("li", { children: ["Kazan\u0131lan ikramiye an\u0131nda \u00FCyenin hesab\u0131na \u015Eans Puan ", "(ŞP)", " olarak y\u00FCklenir. Uygulamam\u0131z ya da sitemiz \u00FCzerinden oynad\u0131\u011F\u0131n\u0131z t\u00FCm oyun t\u00FCrlerinde oyun bedeli \u00F6ncelikle \u015Eans Puan ", "(ŞP)", " alan\u0131ndaki tutar\u0131n\u0131zdan otomatik olarak d\u00FC\u015Fer."] }), _jsxs("li", { children: ["\u015Eans Puanlar\u0131n ", "(ŞP)", " ge\u00E7erlilik tarihi s\u00FCresizdir."] })] })] }))] }));
}
export function ScratchCardWidget(props) {
    var _a, _b;
    var draw = props.draw, setShownDraw = props.setShownDraw;
    var _c = useState(0), selectedQuantity = _c[0], setSelectedQuantity = _c[1];
    var _d = useState(null), showDrawModal = _d[0], setShowDrawModal = _d[1];
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(0), scratchedCardCount = _f[0], setScratchedCardCount = _f[1];
    var _g = useState(false), showTotalWin = _g[0], setShowTotalWin = _g[1];
    var _h = useState(0), totalPayout = _h[0], setTotalPayout = _h[1];
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    var _j = useState(null), sliderRef = _j[0], setSliderRef = _j[1];
    var showCards = function (draw) {
        setShowTotalWin(false);
        setScratchedCardCount(0);
        setTotalPayout(0);
        var payload = {
            has_scratch: false,
            type: "get_draw",
            draw_id: draw.draw_id,
        };
        api.start("post", env.accounting_api + "/somos/api/kazi-kazan/kuponlarim/", payload, true).then(function (res) {
            // console.log(res)
            setShowDrawModal(res.data);
        });
    };
    var screenWidth = window.innerWidth;
    if (screenWidth > 768) {
        screenWidth = 375;
    }
    var cardHeight = ((screenWidth - 40) / 335) * 406;
    var swiper = useSwiper();
    var handleScratchComplete = function (c) {
        var payload = {
            type: "scratch",
            coupons: String(c.id),
        };
        api.start("post", env.accounting_api + "/somos/api/kazi-kazan/kazi/", payload, true).then(function (res) {
            if (res && res.status) {
                // let d:any = dataList.find((e:any)=>e.draw_id===c.draw_id)
                // if(d){
                //   d.not_scratched_count -= 1;
                // }
                c.has_scratched = true;
                // timerSliderChanger = setTimeout(() => {
                //   sliderRef.slideNext();
                // }, 3000);
                c.selections.map(function (s, skey) {
                    var nonUnique = c.selections.filter(function (o) {
                        if (o.value_type === 1 && s.value_type === 1 && o.name === s.name) {
                            return o;
                        }
                        if (o.value_type !== 1 && o.value === s.value) {
                            return o;
                        }
                    }).length;
                    if (nonUnique === 3) {
                        setTotalPayout(totalPayout + Number(s.value));
                        c.is_won = true;
                        c.won_amount = s.value;
                    }
                });
                forceUpdate();
            }
        });
        setScratchedCardCount(scratchedCardCount + 1);
        setTimeout(function () {
            if (scratchedCardCount + 1 == showDrawModal.length) {
                setShowTotalWin(true);
            }
        }, 3000);
    };
    var scratchAll = function () {
        setLoading(true);
        var couponIds = showDrawModal.map(function (el, key) {
            return el.id;
        });
        var totalWon = 0;
        var payload = {
            type: "scratch",
            coupons: couponIds.join(","),
        };
        api.start("post", env.accounting_api + "/somos/api/kazi-kazan/kazi/", payload, true).then(function (res) {
            if (res && res.status) {
                showDrawModal.map(function (c, key) {
                    c.has_scratched = true;
                    c.selections.map(function (s, skey) {
                        var nonUnique = c.selections.filter(function (o) {
                            if (o.value_type === 1 && s.value_type === 1 && o.name === s.name) {
                                return o;
                            }
                            if (o.value_type !== 1 && o.value === s.value) {
                                return o;
                            }
                        }).length;
                        if (nonUnique === 3) {
                            setTotalPayout(totalPayout + Number(s.value));
                            c.is_won = true;
                            c.won_amount = s.value;
                        }
                    });
                    if (c.is_won) {
                        totalWon += Number(c.won_amount);
                    }
                });
                setScratchedCardCount(showDrawModal.length);
                setShowTotalWin(true);
                setTotalPayout(totalWon);
                forceUpdate();
                setLoading(false);
            }
        });
    };
    var buyTicket = function (orderPayload) {
        api
            .start("post", env.accounting_api + "/somos/api/kazi-kazan/kupon-olustur/", orderPayload, true)
            .then(function (res) {
            // console.log(res)
            if (res && res.status) {
                try {
                    // @ts-ignore
                    dataLayer.push({ ecommerce: null });
                    // @ts-ignore
                    // dataLayer.push({
                    //   event: "purchase",
                    //   ecommerce: {
                    //     value: (selectedQuantity == 0 ? 1 : selectedQuantity) * Number(draw.ticket_price), //kullanıcının son ödediği ücret
                    //     transaction_id: Math.random(), //sipariş idsi
                    //     currency: "TRY",
                    //     coupon: "", //Eğer kullanıcı kupon kullandı ise kuponun ismi basılmalıdır.
                    //     payment_type: orderPayload.unit == "0" ? "Balance" : "ŞP", //Ödeme yöntemi. Kredi Kartı, ŞP veya Balance
                    //     purchase_type: "{{Kazı Kazan}}",
                    //     items: [
                    //       {
                    //         item_id: draw.draw_id, // Kazı kazan veya Eşya Çekilişi kuponunun kodu
                    //         item_name: draw.title_abbreviated, //Eğer Kazı Kazan ise kazı kazan görselinin path'i basılmalıdır.
                    //         item_category: "{{Kazı Kazan}}",
                    //         price: draw.ticket_price,
                    //         quantity: selectedQuantity == 0 ? 1 : selectedQuantity,
                    //       },
                    //     ],
                    //   },
                    // });
                    // @ts-ignore
                    dataLayer.push({
                        event: "purchase",
                        ecommerce: {
                            transaction_id: Math.random(),
                            currency: "TRY",
                            value: (selectedQuantity == 0 ? 1 : selectedQuantity) * Number(draw.ticket_price),
                            coupon: "",
                            payment_type: orderPayload.unit == "0" ? "Balance" : "ŞP",
                            userData: {
                                email_address: auth.member.email,
                                phone_number: auth.member.mobile,
                                address: {
                                    first_name: auth.member.first_name,
                                    last_name: auth.member.last_name,
                                    //   city: 'menlopark',
                                    //   region: 'ca',
                                    //   postal_code: '94025',
                                    //   country: 'usa',
                                },
                            },
                            items: [
                                {
                                    item_id: draw.draw_id,
                                    item_name: draw.title_abbreviated,
                                    item_category: "{{Kazı Kazan}}",
                                    price: draw.ticket_price,
                                    quantity: selectedQuantity == 0 ? 1 : selectedQuantity,
                                    // item_brand: "",
                                },
                            ],
                        },
                    });
                }
                catch (e) {
                    console.log(e);
                }
                modalServiceSubject.next({
                    case: "success",
                    title: "".concat(selectedQuantity == 0 ? "1" : selectedQuantity, " Adet e-\u015Eans Kart\u0131"),
                    content: "<p class=\"fw-bold text-center\">Sat\u0131n al\u0131nan kartlar\u0131n en ge\u00E7 23:00'e kadar kaz\u0131nmas\u0131 gerekmektedir.</p>\n                              <p class=\"text-center\">\n                                Kartlar\u0131n kaz\u0131nmamas\u0131 durumunda otomatik olarak kaz\u0131nacak ve kazanan kartlar i\u00E7in \u00F6d\u00FCller \n                                otomatik olarak bakiyenize yans\u0131t\u0131lacakt\u0131r.\n                              </p>",
                    confirm: {
                        cancel: {
                            label: "Kartlarıma git",
                            action: function () {
                                navigate(paths.scratch.url + "/kartlarim");
                            },
                            class: "btn btn-success w-100",
                        },
                        sure: {
                            class: "btn btn-success w-100",
                            label: "Hemen Kazı",
                            action: function () {
                                navigate(paths.scratch.url + "/kartlarim/" + draw.draw_id);
                            },
                        },
                    },
                });
            }
            else {
                if (res.error == "balance_error") {
                    modalServiceSubject.next({
                        case: "danger",
                        title: "Bakiyeniz Yetersiz",
                        width: "400px",
                        content: "<p class=\"text-center\">Kredi Kart\u0131 ile \u00F6demeye devam edebilir veya hesab\u0131n\u0131za bakiye y\u00FCkleyebilirsiniz.</p>",
                        confirm: {
                            sure: {
                                label: "Kredi Kartı İle Öde",
                                class: "btn-warning w-100",
                                action: function () {
                                    openCreditCartModal();
                                },
                            },
                            cancel: {
                                label: "Diğer Ödeme Yöntemleri",
                                class: "btn-info  w-100",
                                action: function () {
                                    window.location.href = paths.deposit.url;
                                },
                            },
                        },
                    });
                }
                else {
                    modalServiceSubject.next({
                        case: "danger",
                        title: "Hay aksi!",
                        width: 400,
                        content: "<p class=\"text-center\">".concat(res.message, "</p>"),
                        confirm: {
                            cancel: {
                                label: "Tamam",
                                class: "btn btn-danger w-100",
                            },
                        },
                    });
                }
            }
        })
            .catch(function (e) {
            exceptionModal(e);
        });
    };
    var buyScratchCard = function () {
        var _a;
        if (!loginRequired(navigate)) {
            return false;
        }
        modalServiceSubject.next({
            case: "info",
            width: "460px",
            title: "İşlemi Onayla",
            content: "<div class=\"text-center\">\n                  ".concat(draw === null || draw === void 0 ? void 0 : draw.title_abbreviated, "\n                  <p class=\"text-center fw-bold\">B\u00FCy\u00FCk \u00D6d\u00FCl: ").concat(draw.big_prize || "-", "</p>\n                  <h4 class=\"text-center fw-bold\">").concat(selectedQuantity == 0 ? "1" : selectedQuantity, " Kart tutar\u0131:  ").concat(((selectedQuantity == 0 ? 1 : selectedQuantity) * Number(draw.ticket_price)).toFixed(2), " TL</h4>\n                  <p>Sat\u0131lan Kartlar\u0131n iadesi yap\u0131lamaz.</p>\n                  <p class=\"mb-0\">\n                    <label>\n                      <input type=\"checkbox\" id=\"id_unit_").concat(draw._id, "\" name=\"terms\" value=\"terms\" /> \u015EP Puan Harca<br />\n                      <i  class=\"fs-7\">Kullan\u0131labilir \u015EP Puan Bakiye: ").concat((_a = auth.member) === null || _a === void 0 ? void 0 : _a.balance_point, " \u015EP</i>\n                    </label>\n                  </p>\n                </p>"),
            confirm: {
                cancel: {
                    label: "Vazgeç",
                    class: "btn btn-secondary w-100",
                },
                sure: {
                    label: "Satın Al",
                    class: "btn btn-success w-100",
                    action: function () {
                        var psPoint = document.getElementById("id_unit_".concat(draw._id));
                        var orderPayload = {
                            draw_no: draw.no,
                            unit: psPoint.checked ? 2 : 0,
                            multiply: selectedQuantity == 0 ? 1 : selectedQuantity,
                        };
                        if (!psPoint.checked &&
                            (selectedQuantity == 0 ? 1 : selectedQuantity) * Number(draw.ticket_price) >
                                Number(auth.member.balance_debit) &&
                            (selectedQuantity == 0 ? 1 : selectedQuantity) * Number(draw.ticket_price) <=
                                Number(auth.member.balance_point)) {
                            setTimeout(function () {
                                modalServiceSubject.next({
                                    case: "danger",
                                    title: "Bakiyeniz Yetersiz!",
                                    width: 400,
                                    content: "<p class=\"text-center\">TL bakiyeniz yetersiz \u015EP kullamak ister misiniz?</p>",
                                    confirm: {
                                        cancel: {
                                            label: "Vazgeç",
                                            class: "btn btn-danger",
                                        },
                                        sure: {
                                            label: "ŞP Kullan",
                                            class: "btn btn-success",
                                            action: function () {
                                                orderPayload.unit = 2;
                                                buyTicket(orderPayload);
                                            },
                                        },
                                    },
                                });
                            }, 500);
                        }
                        else {
                            buyTicket(orderPayload);
                        }
                    },
                },
            },
        });
    };
    if (draw === undefined)
        return _jsx(_Fragment, {});
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "col-12 col-mobile-12 col-lg-6 mb-3" }, { children: _jsxs("div", __assign({ className: "scratch-card" }, { children: [_jsxs("div", __assign({ className: "body", style: {
                                backgroundImage: "url(".concat(env.accounting_api, "/media/").concat(draw.photo, ")"),
                                marginBottom: "0",
                                marginTop: "-1rem",
                            } }, { children: [_jsx("div", __assign({ className: "info text-end", style: { display: "flex", justifyContent: "flex-end" } }, { children: _jsxs("button", __assign({ className: "btn btn-light fw-bold btn-sm rounded-pill", style: {
                                            color: "#0d6efd",
                                            display: "flex",
                                            alignItems: "center",
                                        }, onClick: function () {
                                            setShownDraw(draw);
                                        } }, { children: [draw.ticket_price.toFixed(2), " TL", _jsx("img", { style: { color: "#0d6efd", fill: "#0d6efd" }, src: iconInfo, className: "ms-2" })] })) })), _jsx("div", { className: "desciption" }), _jsxs("div", __assign({ className: "row mx-0 px-1 quantities" }, { children: [_jsx("div", __assign({ className: "col-2 px-1" }, { children: _jsx("button", __assign({ onClick: function () {
                                                    setSelectedQuantity(10);
                                                }, className: "btn btn-sm w-100 fw-bold rounded-3 btn-outline-quantity ".concat(selectedQuantity === 10 ? "active" : "") }, { children: "10" })) })), _jsx("div", __assign({ className: "col-2 px-1" }, { children: _jsx("button", __assign({ onClick: function () {
                                                    setSelectedQuantity(25);
                                                }, className: "btn btn-sm w-100 fw-bold rounded-3 btn-outline-quantity ".concat(selectedQuantity === 25 ? "active" : "") }, { children: "25" })) })), _jsx("div", __assign({ className: "col-2 px-1" }, { children: _jsx("button", __assign({ onClick: function () {
                                                    setSelectedQuantity(50);
                                                }, className: "btn btn-sm w-100 fw-bold rounded-3 btn-outline-quantity ".concat(selectedQuantity === 50 ? "active" : "") }, { children: "50" })) })), _jsx("div", __assign({ className: "col-2 px-1" }, { children: _jsx("button", __assign({ onClick: function () {
                                                    setSelectedQuantity(100);
                                                }, className: "btn btn-sm w-100 fw-bold rounded-3 btn-outline-quantity ".concat(selectedQuantity === 100 ? "active" : "") }, { children: "100" })) })), _jsx("div", __assign({ className: "col-4 px-1" }, { children: _jsx("select", __assign({ value: selectedQuantity, className: "btn btn-sm w-100 fw-bold rounded-3 btn-outline-quantity", onChange: function (e) {
                                                    setSelectedQuantity(Number(e.target.value));
                                                } }, { children: Array.from(Array(100).keys()).map(function (n) {
                                                    return (_jsxs("option", __assign({ value: n }, { children: [n == 0 ? "" : n, " Adet"] }), n));
                                                }) })) }))] }))] })), _jsx("div", __assign({ className: "foot" }, { children: _jsx("button", __assign({ onClick: function () {
                                    buyScratchCard();
                                }, className: "btn btn-success fw-bold w-100 btn-buy" }, { children: "Kart Al" })) }))] })) })), _jsxs(Modal, __assign({ isOpen: showDrawModal !== null, onAfterOpen: function () {
                    document.body.style.overflow = "hidden";
                }, onRequestClose: function () {
                    document.body.style.overflow = "unset";
                    setShowDrawModal(null);
                }, className: "scratch-card-modal", style: {
                    content: {
                        marginLeft: isMobile ? "0" : "calc(50% - 275px)",
                        width: isMobile ? "100%" : screenWidth + 40,
                        height: "calc(100%)",
                        paddingTop: "10px",
                        maxHeight: "525px",
                        paddingBottom: "10px",
                    },
                }, contentLabel: "" }, { children: [_jsx("a", __assign({ className: "modal-close", onClick: function () {
                            document.body.style.overflow = "unset";
                            setShowDrawModal(null);
                        } }, { children: _jsx("img", { src: iconClose }) })), loading ? (_jsx("div", { id: "id_loaderAnimation", className: "loader" })) : (_jsx(_Fragment, { children: showTotalWin ? (_jsxs(_Fragment, { children: [totalPayout > 0 ? (_jsx("h2", __assign({ className: "text-center fw-bold fs-4" }, { children: "Tebrikler" }))) : (_jsx("h2", __assign({ className: "text-center fw-bold fs-4" }, { children: "Tekrar Dene" }))), _jsxs("div", __assign({ className: "scratch-card winner" }, { children: [_jsx("div", __assign({ className: "body p-4" }, { children: totalPayout > 0 ? (_jsxs("div", __assign({ className: "desciption" }, { children: [_jsx("span", { children: "Toplam" }), _jsxs("h2", { children: [totalPayout, " \u20BA"] }), _jsx("span", { children: "\u015EP Puan " }), _jsx("span", { children: "Kazand\u0131n\u0131z" })] }))) : (_jsx("div", __assign({ className: "desciption" }, { children: _jsx("h2", { children: "Biletinize ikramiye \u00E7\u0131kmad\u0131" }) }))) })), _jsx("div", __assign({ className: "foot" }, { children: _jsx("p", { children: "Kazan\u0131lan tutar hesab\u0131na \u015EP Puan Olarak yat\u0131r\u0131lm\u0131\u015Ft\u0131r." }) }))] })), totalPayout > 0 && (_jsxs("div", __assign({ className: "card rounded-4 mt-4" }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsx("h2", __assign({ className: "won-card-header" }, { children: "Kazanan Kart Listesi" })) })), _jsx("div", __assign({ className: "card-body won-tickets-area" }, { children: showDrawModal &&
                                                showDrawModal
                                                    .filter(function (el) { return el.is_won == true; })
                                                    .map(function (el, key) {
                                                    return (_jsxs("div", __assign({ className: "won-ticket-row" }, { children: [_jsxs("span", { children: ["#", el.id] }), _jsxs("span", { children: ["#", el.value_type === 1 ? el.name : el.won_amount] })] }), "won-tickets-" + key.toString()));
                                                }) }))] }))), _jsx("button", __assign({ className: "btn btn-custom w-100 mt-3", onClick: function () {
                                        document.body.style.overflow = "unset";
                                        setShowDrawModal(null);
                                        setShowTotalWin(false);
                                    }, id: "btn_submit" }, { children: "Tekrar Dene" })), _jsx("button", __assign({ className: "btn btn-success w-100 mt-3 fw-bold", onClick: function () {
                                        document.body.style.overflow = "unset";
                                        setShowDrawModal(null);
                                        navigate(paths.scratch.url + "/kartlarim");
                                    }, id: "btn_submit" }, { children: "Kartlar\u0131m" }))] })) : (_jsxs(_Fragment, { children: [showDrawModal && (_jsxs("h2", __assign({ className: "text-center fw-bold fs-6" }, { children: [_jsx("span", __assign({ style: {
                                                fontSize: 14,
                                                display: "block",
                                            } }, { children: (_a = showDrawModal[0].draw) === null || _a === void 0 ? void 0 : _a.title_abbreviated })), "B\u00FCy\u00FCk \u00D6d\u00FCl: ", ((_b = showDrawModal[0].draw) === null || _b === void 0 ? void 0 : _b.big_prize) || "-"] }))), showDrawModal && (_jsxs("h2", __assign({ className: "text-center fw-bold fs-6" }, { children: [scratchedCardCount, " / ", showDrawModal.length] }))), showDrawModal && (_jsx(Swiper, __assign({ spaceBetween: 30, id: "card-slider", allowTouchMove: false, onSlideChange: function (e) {
                                        // clearTimeout(timerSliderChanger);
                                        // let ex: any = document.querySelectorAll('#card-slider');
                                        // let wrapper: any = document.querySelectorAll('#card-slider .swiper-wrapper');
                                        // wrapper[0].style.marginLeft = `unset`;
                                        // wrapper[0].style.transform = `translate3d(${(ex[0].offsetWidth * -1 * e.activeIndex)}px, 0px, 0px);`;
                                        // setTimeout(() => {
                                        //   console.log(ex[0].offsetWidth)
                                        //   wrapper[0].style.marginLeft = `${(ex[0].offsetWidth * -1 * e.activeIndex)}px`;
                                        //   wrapper[0].style.transform = 'unset';
                                        // }, 400);
                                    }, breakpoints: {
                                        0: {
                                            slidesPerView: 1,
                                            spaceBetween: 0,
                                        },
                                    }, onInit: function (ev) {
                                        // console.log(ev)
                                        setSliderRef(ev);
                                    } }, { children: showDrawModal &&
                                        showDrawModal.map(function (el, key) {
                                            var nonUnique = 0;
                                            var prizePayout = 0;
                                            return (_jsx(SwiperSlide, __assign({ id: "card-slider-items-".concat(key) }, { children: _jsxs("div", __assign({ className: "px-3" }, { children: [_jsx(ScratchCard, __assign({}, {
                                                            width: screenWidth - 40,
                                                            height: cardHeight - 90,
                                                            image: couponCover,
                                                            finishPercent: 70,
                                                            onComplete: function () { return handleScratchComplete(el); },
                                                        }, { children: _jsxs("div", __assign({ className: "scratch-off-card" }, { children: [_jsx("img", { style: { height: cardHeight - 90 }, src: couponBg }), _jsx("div", __assign({ className: "row" }, { children: el.selections.map(function (s, skey) {
                                                                            var nonUnique = el.selections.filter(function (o) {
                                                                                if (o.value_type === 1 && s.value_type === 1 && o.name === s.name) {
                                                                                    return o;
                                                                                }
                                                                                if (o.value_type !== 1 && o.value === s.value) {
                                                                                    return o;
                                                                                }
                                                                            }).length;
                                                                            if (nonUnique === 3) {
                                                                                prizePayout = Number(s.value);
                                                                            }
                                                                            return (_jsx("div", __assign({ className: "col-6 ".concat(nonUnique === 3 && el.has_scratched === true
                                                                                    ? "won"
                                                                                    : el.has_scratched === true && nonUnique == 2 && prizePayout == 0
                                                                                        ? "semi-won"
                                                                                        : el.has_scratched === false && s.has_scratched !== true
                                                                                            ? "non-scratched"
                                                                                            : ""), style: {
                                                                                    height: (cardHeight - 90) / 3,
                                                                                } }, { children: s.value_type === 1 ? "".concat(s.name) : "".concat(Number(s.value).toFixed(0), "\u20BA") }), "".concat(skey, "-selection-").concat(key)));
                                                                        }) }))] })) })), showDrawModal && scratchedCardCount != showDrawModal.length && (_jsx("button", __assign({ className: "btn btn-success w-100 mt-2 fw-bold", onClick: function () {
                                                                if (el.has_scratched == false) {
                                                                    scratchAll();
                                                                }
                                                                // else{
                                                                //   sliderRef.slideNext();
                                                                // }
                                                            }, id: "btn_submit" }, { children: el.has_scratched == false ? "Tümünü Kazı 1" : "Sıradaki Karta Geç" })))] })) }), "card-slider-items-".concat(key)));
                                        }) }))), showDrawModal && (_jsx("h2", __assign({ className: "text-center fw-bold fs-5 mt-3" }, { children: _jsx("span", __assign({ style: { fontSize: 14, display: "block" } }, { children: "Ayn\u0131 3 say\u0131y\u0131 bul, \u00F6d\u00FCl\u00FC kazan!" })) })))] })) }))] }))] }));
}
